<template>
    <div
        component="VideoGalleryItem"
        v-click-outside="clickOutside"
        :load="isProcessing"
        :title="isProcessing ? 'Processing...' : ''"
        @click.stop="onClick"
    >
        <div class="holder">
            <div class="icons" v-if="!removeConfirm && isReady">
                <btn class="drag" color="black" size="icon" :icon="'control_camera'" />
                <btn class="close" color="black" size="icon" :icon="'close'" @click.stop="removeConfirm = true" />
            </div>

            <div class="question" :class="{ isVisible: removeConfirm }">
                <label>remove?</label>
                <btn size="icon" color="ghostWhite" :icon="'close'" @click.stop="removeConfirm = false"></btn>
                <btn size="icon" color="white" :icon="'done'" @click.stop="remove"></btn>
            </div>

            <video ref="video" preload="metadata" width="100%" v-if="isReady">
                <source :src="getActorFileUrl(item.file_id)" :type="item.file_mime" />
            </video>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import { portfolioModelStates as states } from '@/model/Actor/PortfolioModel';

export default {
    name: 'VideoGalleryItem',

    directives: {
        ClickOutside,
    },

    props: {
        index: {
            type: Number,
        },

        item: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            removeConfirm: false,
            states: states,
        };
    },

    methods: {
        onClick() {
            if (this.isReady) {
                this.$emit('click', this.item.file_id);
            }
        },

        remove() {
            this.removeConfirm = false;
            this.$emit('remove', this.item);
        },

        clickOutside() {
            this.removeConfirm = false;
        },
    },

    computed: {
        ...mapGetters(['getActorFileUrl']),

        isProcessing() {
            return [states.created, states.processing].includes(this.item.state);
        },

        isReady() {
            return [states.ready].includes(this.item.state);
        },

        hasError() {
            return [states.error].includes(this.item.state);
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='VideoGalleryItem'] {
    position: relative;
    width: 50%;
    .flex-center;
    cursor: pointer;
    padding: 5px 0;

    @media (max-width: 479px) {
        width: 100%;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    &:nth-child(odd) {
        padding-right: 5px;
    }

    &:nth-child(even) {
        padding-left: 10px;
    }

    &[load]:after {
        border-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.4)
            rgba(255, 255, 255, 0.4);
    }

    .holder {
        position: relative;
        display: flex;
        .radius;
        overflow: hidden;
        min-height: 110px;
        width: 100%;
        background: black;

        &:hover {
            .icons {
                opacity: 1;
            }
        }

        .icons {
            .flex-center;
            position: absolute;
            top: 5px;
            right: 5px;
            opacity: 0;
            transition: 0.3s;

            button {
                margin-left: 2px;
            }
        }
    }

    .question {
        .flex-center;
        flex-direction: row;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: fade(black, 50%);
        color: white;
        transition: 0.5s;
        opacity: 0;
        pointer-events: none;

        &.isVisible {
            opacity: 1;
            pointer-events: all;
        }

        label {
            font-weight: 900;
            margin-right: 10px;
            font-size: 18px;
        }

        button {
            margin-right: 5px;
        }
    }
}
</style>
